import { render, staticRenderFns } from "./Special.vue?vue&type=template&id=be12cece&"
import script from "./Special.vue?vue&type=script&lang=ts&"
export * from "./Special.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports